import React, { useState } from "react";
import styles from "./productInfo.scss";
import { UserRoles } from "../../../common/constant";
import { useSelector } from "react-redux";
import { getLoggedInUserInfo } from "../../../common/utils/helper";
import PdpStatusBar from "../pdpStatusBar/pdpStatusBar";
import NoTranslate from "../../../common/components/notranslate/noTranslate";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const breakpoint = useSelector((state) => state.breakpoint);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  if (breakpoint === "sm" || breakpoint === "xs") {
    return (
      <p className={styles["text"]}>
        {text && text.length > 88 && (isReadMore ? text.slice(0, 87) : text)}
        {text && text.length > 88 && (
          <span onClick={toggleReadMore} className={styles["read-or-hide"]}>
            {isReadMore ? "...查看更多" : " 查看更少"}
          </span>
        )}
        {text && text.length <= 88 && text}
      </p>
    );
  } else {
    return (
      <p className={styles["text"]}>
        {text && text.length > 165 && (isReadMore ? text.slice(0, 164) : text)}
        {text && text.length > 165 && (
          <span onClick={toggleReadMore} className={styles["read-or-hide"]}>
            {isReadMore ? "...查看更多" : " 查看更少"}
          </span>
        )}
        {text && text.length <= 165 && text}
      </p>
    );
  }
};
const ProductInfo = (props) => {
  const { productInfo, productStatus, productAnnouncement } = props;
  if (!productInfo) return null;
  const intlNumberFormatter = new Intl.NumberFormat("en-US");

  const LoggedInUserRole = getLoggedInUserInfo().role;

  return (
    <div className={styles["product_description_section"]}>
      {productInfo.productBrand ? (
        <div>
          <div className={styles["product_brand_and_itemcode"]}>
            <span className={styles["brand"]}>{productInfo.productBrand}</span>
            <span className={styles["product_itemcode"]}>
              訂貨代碼: {productInfo.itemCode || 0}
            </span>
          </div>

          <h1 className={styles["product_name"]}>{productInfo.productName}</h1>
        </div>
      ) : (
        <div className={styles["product_brand_and_itemcode"]}>
          <h1 className={styles["product_name"]} style={{ marginTop: "-2px" }}>
            {productInfo.productName}
          </h1>
          <span className={styles["product_itemcode"]}>
            訂貨代碼: {productInfo.itemCode || 0}
          </span>
        </div>
      )}

      {productInfo?.productNameEn && (
        <div className={styles["product_nameEn"]}>
          {productInfo.productNameEn}
        </div>
      )}

      <div className={styles["product_description"]}>
        <div className={styles["mobile_description"]}>
          <ReadMore>{productInfo.summary}</ReadMore>
        </div>
        <div className={styles["desktop_description"]}>
          <ReadMore>{productInfo.summary}</ReadMore>
        </div>
      </div>
      <div className={styles["price_and_stock_status"]}>
        <span className={`${styles["price_and_bonus_points"]}`}>
          <NoTranslate>
            {productInfo?.price
              ? "$ " + intlNumberFormatter.format(Number(productInfo.price))
              : null}
          </NoTranslate>
          {productInfo?.giftPoint && productInfo?.price ? " + " : null}
          {productInfo?.giftPoint
            ? intlNumberFormatter.format(Number(productInfo.giftPoint)) + " 點"
            : null}
        </span>

        {productStatus ? (
          <span
            className={styles["stock_status_out"]}
            style={{ color: productStatus?.colorCode }}
          >
            {productStatus?.label}
          </span>
        ) : null}
      </div>

      {LoggedInUserRole === UserRoles.ABO ? (
        <article className={styles["PV-BV-container"]}>
          <div>
            <span className={styles["PV-content"]}>PV:</span>
            <span className={styles["PV-value"]}>{productInfo.pointValue}</span>
            <span className={styles["BV-content"]}>BV:</span>
            <span className={styles["BV-value"]}>
              {productInfo.businessVolume}
            </span>
          </div>
        </article>
      ) : null}
      {productStatus ? (
        <PdpStatusBar message={productInfo?.estimatedInstockTime?.value} />
      ) : null}
      {productAnnouncement ? (
        <PdpStatusBar
          message={productAnnouncement?.message}
          url={productAnnouncement?.url?.href}
        />
      ) : null}
    </div>
  );
};

export { ProductInfo };
